__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "boilerplate-mfe-consumer";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@plurall/elo-beta", "2.0.0-beta.523", () => (Promise.all([__webpack_require__.e(542), __webpack_require__.e(829), __webpack_require__.e(272), __webpack_require__.e(439), __webpack_require__.e(33)]).then(() => (() => (__webpack_require__(98734))))));
			register("@sentry/browser", "7.119.1", () => (Promise.all([__webpack_require__.e(389), __webpack_require__.e(697), __webpack_require__.e(996), __webpack_require__.e(112), __webpack_require__.e(349)]).then(() => (() => (__webpack_require__(24996))))));
			register("@sentry/browser", "7.120.4", () => (Promise.all([__webpack_require__.e(883), __webpack_require__.e(92), __webpack_require__.e(585)]).then(() => (() => (__webpack_require__(48092))))));
			register("@sentry/integrations", "7.119.1", () => (Promise.all([__webpack_require__.e(389), __webpack_require__.e(483), __webpack_require__.e(697), __webpack_require__.e(15)]).then(() => (() => (__webpack_require__(83015))))));
			register("@sentry/integrations", "7.120.4", () => (Promise.all([__webpack_require__.e(483), __webpack_require__.e(883), __webpack_require__.e(847)]).then(() => (() => (__webpack_require__(95847))))));
			register("@sentry/react", "7.119.1", () => (Promise.all([__webpack_require__.e(389), __webpack_require__.e(481), __webpack_require__.e(829), __webpack_require__.e(611)]).then(() => (() => (__webpack_require__(2481))))));
			register("client-oauth2", "4.3.3", () => (__webpack_require__.e(977).then(() => (() => (__webpack_require__(36977))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(581).then(() => (() => (__webpack_require__(45697))))));
			register("query-string", "7.1.3", () => (__webpack_require__.e(563).then(() => (() => (__webpack_require__(17563))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(829)]).then(() => (() => (__webpack_require__(73935))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(818), __webpack_require__.e(829), __webpack_require__.e(272)]).then(() => (() => (__webpack_require__(49818))))));
			register("react", "18.3.1", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(67294))))));
			initExternal(3323);
			initExternal(52930);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};